import Vue from 'vue'
import Router from 'vue-router'
import settleIn from '@/page/settleIn'
import tutorial from '@/page/tutorial'
import settleIn2 from '@/page/settleIn2'
import settleIn3 from '@/page/settleIn3'
import settleInSuccess from '@/page/settleInSuccess'
import exchange from '@/page/exchange'
import userMessage from '@/page/userMessage'
import CommentPage from "../page/comment.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/settleIn',
      name: 'settleIn',
      component: settleIn
    }, {
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial
    }, {
      path: '/settleIn2',
      name: 'settleIn2',
      component: settleIn2
    }, {
      path: '/settleInSuccess',
      name: 'settleInSuccess',
      component: settleInSuccess
    },
    {
      path: '/settleIn3',
      name: 'settleIn3',
      component: settleIn3
    },
    {
      path: '/userexchange',
      component: exchange
    },
    {
      path: '/userMessage',
      component: userMessage
    },
    {
      path: '/comment',
      component: CommentPage
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js